module.exports = __webpack_public_path__ + "static/cta-bg-2-8b4ef7bb773c43dfb3518d8d9d715982.png";